export enum ClientMode {
  Basic = "Basic",
  Standard = "Standard",
  Interface = "Interface",
}
